<script>
    let newGamePlayersCount = 1;
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
</script>

<div class="section section--number-bar">
    <button
        class="btn"
        on:click={() =>
            dispatch('createGame', { players: newGamePlayersCount })}
    >
        <span class="btn-text__main">Stwórz nową grę</span>
    </button>
    <button class="btn u-margin-top" on:click={() => dispatch('refresh')}>
        <span class="btn-text__main">Odśwież</span>
    </button>
    <button
        class="btn u-margin-top"
        on:click={() => {
            window.open('https://ow.mindlab.pl?mode=tutorial', '_blank');
        }}
    >
        <span class="btn-text__main">Uruchom Tutorial</span>
    </button>
</div>
